export default __webpack_public_path__ + "static/media/file.012903bc.svg";